import type { Contract, STDocument } from '@st/sdk'
import { renderEngagementLetterDocumentTopBar } from './top-bar'
import { contractDocumentId } from '../document-contract'
import type { DocumentView } from '../types'

export function engagementLetterDocumentView({
  document,
  contract,
  baseView
}: {
  document: STDocument
  contract: Contract | undefined
  baseView: DocumentView
}): DocumentView | undefined {
  if (!contract || contractDocumentId(contract) != document.id) {
    return undefined
  }

  return {
    ...baseView,
    renderTopBar: (props) => renderEngagementLetterDocumentTopBar(contract, props)
  }
}
